import { useMemo, ReactNode } from 'react';
import { GlobalContext } from 'src/context/global/global-context';
import { useGlobalContext } from 'src/context/global/use-global-context';
import { ProjectJsonData } from 'src/types/project';

type Props = {
  projectJsonData: ProjectJsonData;
  children: ReactNode;
};

/**
 * Overrides VLAN / subnet context from the import draft so canvas dialogs match
 * the wizard project data (not the live board).
 */
export function ImportDraftGlobalProvider({
  projectJsonData,
  children,
}: Props) {
  const parent = useGlobalContext();
  const value = useMemo(
    () => ({
      ...parent,
      vlans: projectJsonData.vlans,
      globalIpSubnet: projectJsonData.globalIpSubnet ?? parent.globalIpSubnet,
      useCustomVlan: projectJsonData.useCustomVlan,
    }),
    [
      parent,
      projectJsonData.vlans,
      projectJsonData.globalIpSubnet,
      projectJsonData.useCustomVlan,
    ],
  );

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
}
